/// <reference path="../../../../node_modules/@1js/office-online-strings/en-US/transcription-strings.d.ts" />

import Dispatcher from '../../dispatcher';
import { IForegroundTask } from '../../../backend/interfaces/IForegroundTask';
import { LoadingActionTypes, LoadingStatus } from '../../common/enums/loadingEnums';

export function SetForegroundTaskInStore(foregroundTask: IForegroundTask | null) {
  Dispatcher.dispatch({
    type: LoadingActionTypes.SetForegroundTaskAction,
    payload: foregroundTask
  });
}


export function StatusLabelFromLoadingStatus(status: LoadingStatus): string {
  switch (status) {
    case LoadingStatus.UploadingFile:
      return TranscriptionStrings.LoadingPageUploadingStatus;
    case LoadingStatus.TranscribingAudio:
      return TranscriptionStrings.LoadingPageTranscribingStatus;
    case LoadingStatus.LoadingTranscription:
      return TranscriptionStrings.LoadingPageFetchingStatus;
    case LoadingStatus.StorageMigrationInProgress:
      return TranscriptionStrings.StorageMigrationinProgress;
    case LoadingStatus.StorageMigrationCompleted:
      return TranscriptionStrings.StorageMigrationCompleted;
    case LoadingStatus.WaitForConnection:
      return TranscriptionStrings.UnknownProblem + '\n' + '\n' + TranscriptionStrings.EnsureProperConnectivity;
  }
}

export function ProgressLabelFromLoadingStatus(status: LoadingStatus): string {
  const blankString = '';
  switch (status) {
    case LoadingStatus.UploadingFile:
    case LoadingStatus.TranscribingAudio:
      return TranscriptionStrings.LoadingPageTakingLongLabel;

    default:
      return blankString;
  }
}